import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {AMAZON_LISTINGS_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import InfoDialog, {InfoDialogProps, InfoDialogVariants} from 'cl-dialogs/InfoDialog';
import connectWithRouter from '../../redux/connectWithRouter';
import {StoreState} from '../../../../App/initialStore';
import AmazonListingsActions from '../../../ActionsManager/AmazonListingsActions/AmazonListingsActions';
import {getValidData} from 'cl-table/redux/selectors';
import Typography from '@material-ui/core/Typography';
import {getAmazonSites} from '../../../../MyAccount/AmazonListings/amazonListingHelpers';
import {getAmazonSellerNameById} from '../../../../Layout/MyAccountLayout/ApplicationLayoutSelectors';
import {Tables} from 'cl-api';

export interface PublishToAmazonConfirmationDialogProps extends InfoDialogProps {
  count: number;
  sellerName: string;
  siteName: string;
  readyCount: number;
}

class PublishToAmazonConfirmationDialog extends React.PureComponent<PublishToAmazonConfirmationDialogProps> {
  render() {
    const {readyCount, count, sellerName, siteName, onClose, open, ...props} = this.props;
    const allReady = readyCount === count;
    return (
      <InfoDialog
        open={open}
        variant={InfoDialogVariants.Error}
        onClose={onClose}
        fullWidth
        title={`Publish ${count} products to ${sellerName} site ${siteName}`}
        actions={
          <AmazonListingsActions
            types={[AMAZON_LISTINGS_ACTIONS_TYPES.PUBLISH_PRODUCTS_TO_AMAZON]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          />
        }
        message="Processing time may take up to eight hours. A notification will appear once the process is done."
        instructionText={{
          before: (
            <Typography>
              {allReady ? 'All' : readyCount} products are <strong>ready</strong> to be published to this channel
            </Typography>
          ),
          after: (
            <React.Fragment>
              {!allReady ? (
                <Typography>
                  {count - readyCount} products are <strong>not ready</strong> to be published
                </Typography>
              ) : (
                undefined
              )}
            </React.Fragment>
          ),
        }}
        {...props}
      />
    );
  }
}

export default connectWithRouter((state: StoreState) => {
  const tableState = state.table[Tables.PublishToAmazonTable];
  if (tableState) {
    const sellerName = getAmazonSellerNameById(state, tableState.initParams.sellerId);
    const site = tableState.initParams.site;
    return {
      count: tableState.count,
      readyCount: getValidData(tableState).count(),
      sellerName,
      siteName: getAmazonSites(state)[site].text,
    };
  } else {
    return {};
  }
})(PublishToAmazonConfirmationDialog);
